module.exports = __webpack_public_path__ + "img/software_xpressdox.ee904cc8.jpg";